module.exports = __webpack_public_path__ + "img/Compare.c0f3ddd3.svg";